import Vue from 'vue'
import VueCookie from 'vue-cookie'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueGoogleCharts from 'vue-google-charts'
import VModal from 'vue-js-modal'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import router from './router'

Vue.use(VueMoment, {
    moment,
})
Vue.use(VueCookie);
Vue.use(VueRouter)
Vue.use(VModal)
Vue.use(VueGoogleCharts)
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')